import { ProductCard } from "./ProductCard";

export function ProductGrid({ products }) {
  if (!products || products.length === 0) {
    return <p className="text-white/60 text-center" data-testid="no-products">No products found</p>;
  }
  
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="product-grid">
      {products.map((p, i) => <ProductCard key={p.id || i} product={p} />)}
    </div>
  );
}
